import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { ProgramsState } from '../programs/Types';
import { IdleState } from '../idle/Types';
import CommonFeatures from '../commons/CommonFeatures';
import ReactTable from 'react-table';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import { cannotWrite, cannotUpdate, isMemberDisabled, isPaymentDisabled } from '../util/permission.util';
import { Member, PaymentInfo, MembersState, MembersResponseData } from '../members/members.types';
import { MAX_NOTE_LENGTH, PACKAGE_BASED } from 'src/members/members.constants';
import { PACKAGE } from 'src/account/Constants';
import { isPackageDisabled } from '../util/permission.util';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import AutoComplete from 'material-ui/AutoComplete';
import { BusinessState } from 'src/business/business.types';
import * as validator from 'validator';
import ReactDatePicker from 'react-datepicker';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import * as moment from 'moment';
import SectionPanel from '../util/SectionPanelComponent';
import { PackageState, MmsPackage, MmsPackageHistory } from './Types';
import FontIcon from 'material-ui/FontIcon';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import { black } from 'material-ui/styles/colors';
import { Account } from '../account/Types';
import Dialog from 'material-ui/Dialog';
import { dateFromString } from 'src/util/date-util';

const fieldStyles = {
  rootStyle: {
    cursor: 'text'
  },
  textStyle: {
    color: black
  },
  dividerStyle: {
    backgroundColor: 'rgb(0, 188, 212)'
  }
};

const paperStyle = {
  height: '100%',
  width: '100%'
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly membersState: MembersState
  readonly programsState: ProgramsState
  readonly businessState: BusinessState
  readonly idleState: IdleState
  readonly packageState: PackageState
  readonly toDashboard: () => void
  readonly getMembers: () => Promise<MembersResponseData>
  readonly getMember: (memberId: number) => Promise<MembersResponseData>
  readonly createPackage: (
    id: number, 
    description: string, 
    memberId: number,
    purchaseDate: number,
    expiryDate: number,
    totalClasses: number,
    paymentId?: number
  ) => Promise<Response>
  readonly deletePackage: (id: number) => Promise<Response>
  readonly updatePackage: (
    id: number, 
    description: string, 
    memberId: number,
    purchaseDate: number,
    expiryDate: number,
    totalClasses: number,
    paymentId?: number
  ) => Promise<Response>
  readonly getPackages: () => Promise<Response>
};

type States = {
  readonly description: string
  readonly editedDescription: string
  readonly descriptionError: string
  readonly isNew: boolean
  readonly selectedMember: Member
  readonly editedSelectedMember: Member
  readonly selectedPayment: PaymentInfo
  readonly editedSelectedPayment: PaymentInfo
  readonly searchText: string
  readonly dataSource: string[]
  readonly membersLoading: boolean
  readonly membersLoadingError: string
  readonly loadingMember: boolean
  readonly loadingMemberError: string
  readonly total: number
  readonly editedTotal: number
  readonly selectedPurchaseDate: any
  readonly editedSelectedPurchaseDate: any
  readonly selectedExpiryDate: any
  readonly editedSelectedExpiryDate: any
  readonly selectedRow: MmsPackage
  readonly creatingPackage: boolean
  readonly classesToAdd: number
  readonly expiryDateError: string
  readonly loadingPackages: boolean
  readonly loadingPackagesError: string
  readonly remainingClasses: number
  readonly filterByMemberName: string
  readonly filterByDescription: string
  readonly packages: MmsPackage[]
  readonly updatingPackageError: string
  readonly remainingClassesError: string
  readonly openDeleteWarningModal: boolean
  readonly deletingPackage: boolean
  readonly deletingPackageError: string
  readonly selectedPackageStatus: string
};

class PackageComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      description: '',
      editedDescription: '',
      descriptionError: '',
      isNew: false,
      selectedMember: undefined,
      editedSelectedMember: undefined,
      selectedPayment: undefined,
      editedSelectedPayment: undefined,
      searchText: '',
      dataSource: this.mapMemberToNameAndPhoneAndMemberId(props),
      membersLoading: false,
      membersLoadingError: '',
      loadingMember: false,
      loadingMemberError: '',
      total: 0,
      editedTotal: 0,
      selectedPurchaseDate: undefined,
      editedSelectedPurchaseDate: undefined,
      selectedExpiryDate: undefined,
      editedSelectedExpiryDate: undefined,
      selectedRow: undefined,
      creatingPackage: false,
      classesToAdd: 0,
      expiryDateError: '',
      loadingPackages: false,
      loadingPackagesError: '',
      remainingClasses: 0,
      filterByMemberName: '',
      filterByDescription: '',
      packages: props.packageState.packages,
      updatingPackageError: '',
      remainingClassesError: '',
      openDeleteWarningModal: false,
      deletingPackage: false,
      deletingPackageError: '',
      selectedPackageStatus: 'ALL'
    };
  }

  componentDidMount() {
    if (isPackageDisabled(this.props.authState, this.props.adminState)) {
      this.props.toDashboard();
    } else {
      this.handleGetPackagesApiCall();
    }

    if (!isMemberDisabled(this.props.authState, this.props.adminState)) {
      this.setState({ membersLoading: true}, () => {
        this.props.getMembers().then(
          response => {
            switch (this.props.membersState.statusCode) {
              case 200: 
                return this.setState({ 
                  membersLoading: false,
                  membersLoadingError: ''
                });
              case 400: 
                return this.setState({ 
                  membersLoading: false,
                  membersLoadingError: 'Loading member list failed'
                });
              default: 
                return this.setState({ 
                  membersLoading: false,
                  membersLoadingError: 'Loading member list failed'
                });
            }
          }
        );
      });
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps && nextProps.packageState.packages && nextProps.packageState.packages.length > 0) {
      this.setState({
        packages: nextProps.packageState.packages
      });
    }
  }

  componentWillUnmount() {
    this.resetAll();
  }

  render() {
    return(
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        
        <div className="page-header-row row mt-2 mb-3">
          <div className="col-auto">
            <h3>Packages</h3>
          </div>
        </div>

        {this.state.selectedRow || this.state.isNew ?
          this.renderPackageDetails() :
          this.renderPackagesTable()
        }
        {this.renderDeleteWarningModal()}
      </CommonFeatures>
    );
  }

  private renderDeleteWarningModal = (): JSX.Element => {
    return(
      <Dialog
        title="Warning"
        actions={[
          this.renderNoButton(),
          this.renderYesButton()
        ]}
        open={this.state.openDeleteWarningModal}
        autoScrollBodyContent={true}
        repositionOnUpdate={false}
        onRequestClose={() => this.setState({ openDeleteWarningModal: false })}
      >
        {
          <b>
            Do you really want to delete the package?
          </b>
        } <br/>
        {this.state.deletingPackageError !== '' ?
          <b className="red">
            {this.state.deletingPackageError}
          </b> :
          null
        }
      </Dialog>
    );
  }

  private renderNoButton = (): JSX.Element => {  
    return(
      <RaisedButton 
        label={'NO'} 
        secondary={true}
        disabled={this.state.deletingPackage}
        onClick={() => this.setState({ openDeleteWarningModal: false })}
      />
    );
  }

  private renderYesButton = (): JSX.Element => {
    return(
      <RaisedButton 
        label={'YES'}
        disabled={this.state.deletingPackage}
        onClick={() => this.handleDeletePackagesApiCall(true)}
      />
    );
  }

  private renderPackagesTable = (): JSX.Element => {
    return(
      <SectionPanel
        className="row mt-5 mb-5"
        title="Packages"
        titleAlign="center"
        rightButtonText="New"
        rightButtonDisabled={
          cannotWrite(PACKAGE, this.props.authState, this.props.adminState)
        }
        rightButtonAction={() => this.setState({ 
          isNew: true,
          description: '',
          editedDescription: '',
          descriptionError: '',
          selectedMember: undefined,
          editedSelectedMember: undefined,
          selectedPayment: undefined,
          editedSelectedPayment: undefined,
          searchText: '',
          total: 0,
          editedTotal: 0,
          selectedPurchaseDate: undefined,
          editedSelectedPurchaseDate: undefined,
          selectedExpiryDate: undefined,
          editedSelectedExpiryDate: undefined,
          selectedRow: undefined,
          classesToAdd: 0,
          remainingClasses: 0
        })}
      >
        {this.state.loadingPackagesError !== '' ? 
          <b className="col-12 pt-3 pb-3 red">{this.state.loadingPackagesError}</b> :
          null
        }
        <div className="col-auto">
          <SelectField
            floatingLabelText="Filter By Status"
            value={this.state.selectedPackageStatus}
            onChange={this.handleStatusFilterChange}
          >
            <MenuItem value={'ALL'} primaryText={'All'} />
            <MenuItem value={'ACTIVE'} primaryText={'Active'} />
            <MenuItem value={'INACTIVE'} primaryText={'Inactive'} />
          </SelectField>
        </div>
        <div className="col-auto">
          <TextField
            hintText="Filter By Member Name"
            floatingLabelText="Filter by Member Name"
            onChange={this.handleMemberNameFilterChange}
          />
        </div>
        <div className="col-auto">
          <TextField
            hintText="Filter By Description"
            floatingLabelText="Filter by Description"
            onChange={this.handleDescriptionFilterChange}
          />
        </div>
        <div 
          className="col-12 pt-3 pb-3"
          style={overlayStyle(!this.state.loadingPackages)}
        >
          {renderOverlayLoading(!this.state.loadingPackages, '25%')}
          <ReactTable
            data={this.state.packages.length > 0 && !this.state.loadingPackages ?
              this.createFilteredPackages().map(p => this.createTableData(p)) :
              []
            }
            columns={
              [
                {
                  Header: 'Member',
                  accessor: 'member',
                  style: {textAlign: 'center'}
                },
                {
                  Header: 'Description',
                  accessor: 'description',
                  style: {textAlign: 'center'}
                },
                {
                  Header: 'Purchase Date',
                  accessor: 'purchaseDate',
                  sortMethod: (a, b, desc) => {
                    if (dateFromString(a) > dateFromString(b)) {
                      return 1;
                    } else if (dateFromString(a) < dateFromString(b)) {
                      return -1;
                    } else {
                      return 0;
                    }
                  },
                  style: {textAlign: 'center'}
                }
              ]
            }
            defaultPageSize={20}
            className="-striped -highlight"
            getTdProps={(state, rowInfo, column, instance) => {
              return {
                onClick: (e, handleOriginal) => rowInfo ? this.handleCellClick(rowInfo.index) : null
              };
            }}
          />
        </div>
      </SectionPanel>
    );
  }

  private handleGetPackagesApiCall = (callReset?: boolean) => {
    this.setState({
      loadingPackages: true
    }, () => {
      this.props.getPackages().then(res => {
        switch (this.props.packageState.statusCode) {
          case 200:
            return this.setState({
              loadingPackagesError: '',
              loadingPackages: false
            }, () => callReset ? this.resetAll() : null);
          case 403:
          return this.setState({
            loadingPackagesError: 'Failed to load pakcages',
            loadingPackages: false
          });
          default:
            return this.setState({
              loadingPackages: false
            });
        }
      });
    });
  }

  private handleDeletePackagesApiCall = (callReset?: boolean) => {
    if (this.state.selectedRow) {
      this.setState({
        deletingPackage: true
      }, () => {
        this.props.deletePackage(this.state.selectedRow.id).then(re => {
          switch (this.props.packageState.statusCode) {
            case 200:
              return this.setState({
                loadingPackages: true
              }, () => {
                this.props.getPackages().then(res => {
                  switch (this.props.packageState.statusCode) {
                    case 200:
                      return this.setState({
                        loadingPackagesError: '',
                        loadingPackages: false,
                        deletingPackage: false
                      }, () => callReset ? this.resetAll() : null);
                    case 403:
                      return this.setState({
                        loadingPackagesError: 'Failed to load pakcages',
                        loadingPackages: false,
                        deletingPackage: false
                      });
                    default:
                      return this.setState({
                        loadingPackages: false,
                        deletingPackage: false,
                        deletingPackageError: 'Failed to delete the package'
                      });
                  }
                });
              });
            default:
              return;
          }
        });
      });
    }
  }

  private createFilteredPackages = (): MmsPackage[] => {
    return this.state.packages
      .filter(p => {
        const member = this.props.membersState.members.find(m => m.id === p.memberId);

        return p.description.toLowerCase().includes(this.state.filterByDescription) && (member && 
          (member.firstName + ' ' + member.lastName).toLowerCase().includes(this.state.filterByMemberName))
          && this.checkStatus(p);
      });
  }

  private checkStatus = (pkg: MmsPackage): boolean => {
    if (this.state.selectedPackageStatus === 'ALL') {
      return true;
    } else if (this.state.selectedPackageStatus === 'ACTIVE') {
      return pkg.remainingClasses > 0 && pkg.expiryDate > new Date().getMilliseconds();
    } else {
      return pkg.remainingClasses === 0 || pkg.expiryDate <= new Date().getMilliseconds();
    }
  }

  private handleStatusFilterChange = (event: React.FormEvent<HTMLInputElement>, index: number, value: string): void =>
  this.setState({ selectedPackageStatus: value })

  private handleMemberNameFilterChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ filterByMemberName: newValue.toLowerCase() })

  private handleDescriptionFilterChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ filterByDescription: newValue.toLowerCase() })

  private handleCellClick = (i: number) => {
    const p = this.createFilteredPackages()[i];
    const { membersState, businessState } = this.props;
    const foundMember = membersState.members.find(m => m.id === p.memberId);

    if (foundMember) {
      this.setState({loadingMember: true}, () => {
        this.props.getMember(foundMember.id).then(res => {
          switch (this.props.membersState.statusCode) {
            case 200:
              return this.setState({
                loadingMemberError: '',
                loadingMember: false,
                selectedRow: p,
                isNew: false,
                description: p.description,
                editedDescription: p.description,
                total: p.totalClasses,
                editedTotal: p.totalClasses,
                selectedMember: this.props.membersState.member,
                editedSelectedMember: this.props.membersState.member,
                selectedPayment: this.props.membersState.member.payments.find(pa => pa.id === p.paymentId),
                editedSelectedPayment: this.props.membersState.member.payments.find(pa => pa.id === p.paymentId),
                selectedExpiryDate: moment(new Date(p.expiryDate)),
                editedSelectedExpiryDate: moment(new Date(p.expiryDate)),
                selectedPurchaseDate: moment(new Date(p.purchaseDate)),
                editedSelectedPurchaseDate: moment(new Date(p.purchaseDate))
              });
            default:
              return this.setState({loadingMember: false});
          }
        });
      });
    }
  }

  private createTableData = (p: MmsPackage) => {
    const { membersState } = this.props;

    return {
      member: membersState.members.find(m => m.id === p.memberId) ?
        membersState.members.find(m => m.id === p.memberId).firstName + ' ' + 
          membersState.members.find(m => m.id === p.memberId).lastName :
        null,
      description: p.description,
      purchaseDate: moment(new Date(p.purchaseDate)).format('MMM DD YYYY')
    };
  }

  private resetAll = () => {
    this.setState({
      description: '',
      editedDescription: '',
      descriptionError: '',
      isNew: false,
      selectedMember: undefined,
      editedSelectedMember: undefined,
      selectedPayment: undefined,
      editedSelectedPayment: undefined,
      searchText: '',
      membersLoading: false,
      membersLoadingError: '',
      loadingMember: false,
      loadingMemberError: '',
      total: 0,
      editedTotal: 0,
      selectedExpiryDate: undefined,
      editedSelectedExpiryDate: undefined,
      selectedPurchaseDate: undefined,
      editedSelectedPurchaseDate: undefined,
      selectedRow: undefined,
      creatingPackage: false,
      classesToAdd: 0,
      expiryDateError: '',
      loadingPackages: false,
      loadingPackagesError: '',
      filterByMemberName: '',
      filterByDescription: '',
      updatingPackageError: '',
      remainingClassesError: '',
      openDeleteWarningModal: false,
      deletingPackage: false,
      deletingPackageError: ''
    });
  }

  private renderPackageDetails = (): JSX.Element => {
    const { 
      descriptionError, 
      editedDescription, 
      isNew,
      selectedMember,
      editedSelectedMember, 
      editedSelectedPayment,
      loadingMember,
      editedTotal,
      editedSelectedExpiryDate,
      editedSelectedPurchaseDate,
      classesToAdd,
      expiryDateError
    } = this.state;
    const { authState, adminState } = this.props;

    return(
      <Paper style={paperStyle} zDepth={3}>
        <div className="row mt-2 mb-2 no-gutters">
          <div className="col-6 pl-2 pr-2">
            <TextField
              fullWidth={true}
              floatingLabelText="Description"
              errorText={descriptionError}
              value={editedDescription}
              onChange={this.onDescriptionChange}
              disabled={
                (isNew && cannotWrite(PACKAGE, authState, adminState)) ||
                (!isNew && cannotUpdate(PACKAGE, authState, adminState))
              }
            />
          </div>
        </div>
        <div className="row mt-2 mb-2 no-gutters">
          <div className="col-6 pl-2 pr-2">
            {
              editedSelectedMember ?
                this.renderSelectedMember() :
                this.renderAutoCompleteInput()
            }
          </div>
          <div className="col-6 pr-2">
            {editedSelectedMember ?
              <SelectField
                fullWidth={true}
                floatingLabelText={isPaymentDisabled(this.props.authState, this.props.adminState) ?
                  'Not Enough Permission (Payment)' : 
                  'Payment'} 
                disabled={loadingMember || isPaymentDisabled(this.props.authState, this.props.adminState)}
                value={editedSelectedPayment}
                onChange={this.onSelectedPaymentChange}
              >
                {
                  editedSelectedMember ?
                    editedSelectedMember.payments
                    .filter((v: PaymentInfo, i: number) => v.active === true)
                    .map((v: PaymentInfo, i: number) => { 
                      return <MenuItem 
                        key={i} 
                        value={v} 
                        primaryText={v.description ? 
                          v.description + ' - ' + `$${v.amountPerTransaction}` : 
                          'No payment description' + ' - ' + `$${v.amountPerTransaction}`
                        } 
                      />;
                    })  :
                    []
                }
              </SelectField> :
              null
            }
          </div>
        </div>
        <div className="row mt-2 mb-2 no-gutters">
          <div className="col-3 pl-2 pr-2">
            <TextField
              errorText={this.state.remainingClassesError}
              fullWidth={true}
              floatingLabelText="remaining classes / total classes"
              value={isNew ? 
                `${editedTotal} / ${editedTotal}` :  
                this.createTableDataForHistory() ? 
                  `${editedTotal - this.createTableDataForHistory().length} / ${editedTotal}` :
                  ''
              }
              disabled={
                (isNew && cannotWrite(PACKAGE, authState, adminState)) ||
                (!isNew && cannotUpdate(PACKAGE, authState, adminState))
              }
            />
          </div>
          <div className="col-3 pr-2">
            <div className="mt-2 position-absolute">
              <IconButton
                className="position-absolute"
                style={{height: '20px'}}
                onClick={() => this.onAddTotalChange()}
              >
                <FontIcon className="material-icons">add_circle</FontIcon>
              </IconButton>
              <IconButton
                style={{height: '20px', top: '25px'}}
                onClick={() => this.onRemoveTotalChange()}
              >
                <FontIcon className="material-icons">remove_circle_outline</FontIcon>
              </IconButton>
            </div>
            <TextField
              floatingLabelText="Add Classes"
              floatingLabelFixed={true}
              value={classesToAdd}
              onChange={this.onAddMoreClassesChange}
              style={fieldStyles.rootStyle}
              inputStyle={fieldStyles.textStyle}
              floatingLabelStyle={fieldStyles.textStyle}
              className="ml-5"
            />
          </div>
        </div>
        <div className="row mt-2 mb-2 no-gutters">
          <div className="col-6 pl-2 pr-2">
            <div>Purchase Date</div>
            <ReactDatePicker
              selected={editedSelectedPurchaseDate}
              onChange={(date) => this.handlePurchaseDateChange(date)}
              disabled={true}
            />
          </div>
          <div className="col-6 pl-2 pr-2">
            {expiryDateError ? <b className="red">{expiryDateError}</b>  : <div>Expiry Date</div>}
            <ReactDatePicker
              selected={editedSelectedExpiryDate}
              onChange={(date) => this.handleExpiryDateChange(date)}
              disabled={
                (isNew && cannotWrite(PACKAGE, authState, adminState)) ||
                (!isNew && cannotUpdate(PACKAGE, authState, adminState))
              }
            />
          </div>
        </div>
        {
          isNew ?
            null :
            <div className="row mt-2 mb-2 no-gutters">
              <div className="col-12 pl-2 pr-2">
                <div>History</div>
                <ReactTable
                  data={this.createTableDataForHistory()}
                  columns={
                    [
                      {
                        Header: 'Member',
                        accessor: 'member',
                        style: {textAlign: 'center'}
                      },
                      {
                        Header: 'Staff',
                        accessor: 'staff',
                        style: {textAlign: 'center'}
                      },
                      {
                        Header: 'Description',
                        accessor: 'description',
                        style: {textAlign: 'center'}
                      },
                      {
                        Header: 'Date',
                        accessor: 'date',
                        sortMethod: (a, b, desc) => {
                          if (dateFromString(a) > dateFromString(b)) {
                            return 1;
                          } else if (dateFromString(a) < dateFromString(b)) {
                            return -1;
                          } else {
                            return 0;
                          }
                        },
                        style: {textAlign: 'center'}
                      }
                    ]
                  }
                  defaultPageSize={20}
                  className="-highlight"
                />
              </div>
            </div>
        }
        <div className="row mt-3 pb-3 pr-2 no-gutters justify-content-end">
          {this.state.updatingPackageError ?
            <div className="col-auto red mr-3">{this.state.updatingPackageError}</div> :
            null
          }
          <div className="col-auto mr-3">
            {this.state.loadingPackages ?
              <RefreshIndicator
                size={40}
                left={10}
                top={0}
                status="loading"
                style={{
                  display: 'inline-block',
                  position: 'relative',
                }}
              /> :
              <RaisedButton 
                label={'Close'} 
                secondary={true}
                onClick={() => this.handleGetPackagesApiCall(true)}
              />
            }
          </div>
          <div className="col-auto mr-3">
            {this.state.loadingPackages ?
              <RefreshIndicator
                size={40}
                left={10}
                top={0}
                status="loading"
                style={{
                  display: 'inline-block',
                  position: 'relative',
                }}
              /> :
              <RaisedButton 
                label={'Delete'} 
                secondary={true}
                onClick={() => this.setState({ openDeleteWarningModal: true })}
              />
            }
          </div>
          <div className="col-auto">
            <RaisedButton 
              label={isNew ? 'Create' : 'Update'} 
              primary={true}
              disabled={this.doesErrorExist()}
              onClick={() => {
                this.setState({
                  creatingPackage: true
                }, () => {
                  (isNew ?
                    this.props.createPackage(
                      0,
                      this.state.editedDescription, 
                      this.state.editedSelectedMember.id,
                      undefined,
                      this.state.editedSelectedExpiryDate.valueOf(),
                      this.state.editedTotal,
                      this.state.editedSelectedPayment ? this.state.editedSelectedPayment.id : undefined
                    ) :
                    this.props.updatePackage(
                      this.state.selectedRow.id,
                      this.state.editedDescription, 
                      this.state.editedSelectedMember.id,
                      undefined,
                      this.state.editedSelectedExpiryDate.valueOf(),
                      this.state.editedTotal,
                      this.state.editedSelectedPayment ? this.state.editedSelectedPayment.id : undefined
                    )
                  ).then(res => {
                    switch (this.props.packageState.statusCode) {
                      case 200:
                        return this.setState({ 
                          creatingPackage: false,
                          updatingPackageError: '',
                          isNew: false,
                          selectedRow: undefined
                        }, () => {
                          this.setState({loadingPackages: true}, () => {
                            this.props.getPackages().then(resp => {
                              switch (this.props.packageState.statusCode) {
                                case 200:
                                  return this.setState({
                                    loadingPackagesError: '',
                                    loadingPackages: false
                                  });
                                default:
                                  return this.setState({
                                    loadingPackagesError: 'Failed to load pakcages',
                                    loadingPackages: false
                                  });
                              }
                            });
                          });
                        });
                      default:
                        return this.setState({ 
                          updatingPackageError: 'Failed to update the package.',
                          creatingPackage: false 
                        });
                    }
                  });
                });
              }}
            />
          </div>
        </div>
      </Paper>
    );
  }

  private createTableDataForHistory = () => {
    const { packageState, membersState, businessState } = this.props;
    const { selectedRow, isNew, selectedMember, editedSelectedMember } = this.state;
    
    if (!isNew && 
      packageState.packages.length > 0 && 
      membersState.member && 
      selectedRow &&
      selectedMember && editedSelectedMember && selectedMember.memberId === editedSelectedMember.memberId
    ) {
      const found = packageState.packages.find((p: MmsPackage) => p.id === selectedRow.id);

      return found && found.history.map((h: MmsPackageHistory) => {
        const foundStaff = businessState.business && businessState.business.accounts
          .find((a: Account) => a.id === h.accountId);

        return {
          member: h.member.firstName + ' ' + h.member.lastName,
          staff: foundStaff && (foundStaff.firstName + ' ' + foundStaff.lastName),
          description: found.description,
          date: moment(new Date(h.time)).format('MMM Do YY HH:mm')
        };
      });
    } else {
      return [];
    }
  }

  private onAddMoreClassesChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    if (validator.isNumeric(newValue)) {
      const newClassesToAdd = parseInt(newValue, 10);
      
      this.setState({
        classesToAdd: isNaN(newClassesToAdd) ? 0 : newClassesToAdd
      });
    } else {
      this.setState({
        classesToAdd: 0
      });
    }
  }

  private doesErrorExist = (): boolean => {
    const {
      description,
      editedDescription,
      selectedExpiryDate,
      editedSelectedExpiryDate,
      selectedMember,
      editedSelectedMember,
      total,
      editedTotal,
      isNew,
      descriptionError,
      loadingMemberError,
      membersLoadingError
    } = this.state;

    if (isNew) {
      return editedDescription === '' ||
        editedSelectedExpiryDate === undefined ||
        editedSelectedMember === undefined ||
        editedTotal === 0 ||
        descriptionError !== '' ||
        loadingMemberError !== '' ||
        membersLoadingError !== '' ||
        new Date() >= editedSelectedExpiryDate.valueOf();
    } else {
      return (description === editedDescription &&
        selectedExpiryDate.valueOf() === editedSelectedExpiryDate.valueOf() &&
        (editedSelectedMember && selectedMember.id === editedSelectedMember.id) &&
        total === editedTotal) ||
        editedDescription === '' ||
        editedSelectedExpiryDate === undefined ||
        editedSelectedMember === undefined ||
        editedTotal === 0 ||
        descriptionError !== '' ||
        loadingMemberError !== '' ||
        new Date() >= editedSelectedExpiryDate.valueOf() ||
        membersLoadingError !== '';
    }
  }

  private handlePurchaseDateChange = (date): void => this.setState({ editedSelectedPurchaseDate: date });

  private handleExpiryDateChange = (date): void => this.setState((prevState) => ({ 
    editedSelectedExpiryDate: date,
    expiryDateError: new Date() >= date.valueOf() ? 
      'Expiry Date must be later than the Purchase Date' :
      ''
  }))

  private renderAutoCompleteInput = (): JSX.Element => {
    const {
      searchText,
      dataSource,
      membersLoading,
      membersLoadingError,
      loadingMember
    } = this.state;

    if (membersLoading || loadingMember) {
      return(
        <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        />
      );
    } else if (membersLoadingError !== '') {
      return(
        <b className="red">{membersLoadingError}</b>
      );
    } else {
      return(
        <AutoComplete
          hintText={isMemberDisabled(this.props.authState, this.props.adminState) ?
            'Not Enough Permission (Member)' :
            'Member'}
          floatingLabelText={isMemberDisabled(this.props.authState, this.props.adminState) ?
            'Not Enough Permission (Member)' :
            'Member'}
          searchText={searchText}
          onUpdateInput={this.handleSearchTextUpdate}
          dataSource={dataSource}
          onNewRequest={this.handleNewRequest}
          filter={AutoComplete.fuzzyFilter}
          maxSearchResults={5}
          fullWidth={true}
          disabled={isMemberDisabled(this.props.authState, this.props.adminState)}
        />
      );
    }
  }

  private handleNewRequest = (chosenRequest: string, index: number) => {
    const found = this.props.membersState.members.find((m: Member) =>
      m.firstName + ' ' + m.lastName + ', ' + m.mobile1 + ', ' + m.memberId === chosenRequest
    );

    if (found) {
      return this.setState({ loadingMember: true}, () => {
        this.props.getMember(found.id)
        .then(res => {
          switch (this.props.membersState.statusCode) {
            case 200:
              return this.setState({
                loadingMember: false,
                loadingMemberError: '',
                editedSelectedMember: this.props.membersState.member,
                remainingClassesError: ''
              });
            default:
              return this.setState({
                loadingMember: false,
                loadingMemberError: 'Loading a member failed.',
                editedSelectedMember: undefined
              });
          }
        });
      });
    } else {
      return null;
    }
  }

  private mapMemberToNameAndPhoneAndMemberId = (props: Props): string[] => {
    return props.membersState.members
      .filter((m: Member) => m.memberType === PACKAGE_BASED && !m.cancelled)
      .map((m: Member) => m.firstName + ' ' + m.lastName + ', ' + m.mobile1 + ', ' + m.memberId);
  }

  private handleSearchTextUpdate = (searchText: string): void =>
    this.setState({ searchText: searchText })

  private renderSelectedMember = (): JSX.Element => {
    const { editedSelectedMember } = this.state;

    return(
      <Chip
        onRequestDelete={this.handleRequestDelete}
        labelStyle={{height: 50, width: '100%', fontSize: 14}}
        style={{height: 50, width: '100%'}}
        className="mt-3"
      >
        <Avatar
          src={editedSelectedMember && editedSelectedMember.picUrl}
          style={{height: 50, width: 50}}
        />
        {
          editedSelectedMember && editedSelectedMember.firstName + ' ' + editedSelectedMember.lastName
        } /
        {
          editedSelectedMember && editedSelectedMember.mobile1
        } /
        {
          editedSelectedMember && editedSelectedMember.memberId
        }
      </Chip>
    );
  }

  private handleRequestDelete = (): void =>
    this.setState({
      editedSelectedMember: undefined,
      editedSelectedPayment: undefined,
      remainingClasses: 0,
      editedTotal: 0,
      remainingClassesError: 'Member is changed. Please set new member first',
      searchText: ''
    })

  private onSelectedPaymentChange = (
    event: React.TouchEvent<HTMLSelectElement>,
    index: number,
    value: PaymentInfo
  ): void => this.setState({ editedSelectedPayment: value })

  private onDescriptionChange = (e: React.FormEvent<{}>, newValue: string): void => {
    this.setState({
      editedDescription: newValue, 
      descriptionError: newValue.length > MAX_NOTE_LENGTH ? 'Description is too long' : '',
    });
  }

  private onAddTotalChange = (): void => {
    this.setState((prevState) => ({
      editedTotal: prevState.editedTotal + prevState.classesToAdd,
      remainingClassesError: ''
    }));
  }

  private onRemoveTotalChange = (): void => {
    this.setState((prevState) => ({
      editedTotal: (prevState.editedTotal - this.createTableDataForHistory().length - prevState.classesToAdd >= 0) ? 
        prevState.editedTotal - prevState.classesToAdd : 
        prevState.editedTotal,
      remainingClassesError: (prevState.editedTotal - 
        this.createTableDataForHistory().length - prevState.classesToAdd >= 0) ?
        '' :
        'Insufficient Classes'
    }));
  }
}

export default PackageComponent;



// WEBPACK FOOTER //
// ./src/mms-package/PackageComponent.tsx